/* eslint-disable */
// const sanityClient = require("@sanity/client");
//
// const client = sanityClient({
//   projectId: "kj5n9ivc",
//   dataset: "production",
//   apiVersion: "2021-06-07", // use a UTC date string
//   token: "",
//   useCdn: true, // `false` if you want to ensure fresh data
// });

const getTags = async (language_code = "en") => {
  return await fetch(
    `https://us-central1-zefi-cms.cloudfunctions.net/getTags/${language_code}`,
    { method: "GET" }
  )
    .then((res) => res.json())
    .then((json) => json)
    .catch((error) => {
      console.log(error);
    });
};

export { getTags };
